import React, { FC, ReactNode } from 'react';
import { CircularProgress } from '@mui/material';
import { Button } from 'reactstrap';
import colors from 'src/styles/equalution/colors';

interface ActionButtonProps {
  isLoading: boolean;
  disabled?: boolean;
  onClick: () => void;
  children: ReactNode;
  style?: React.CSSProperties;
  size?: string;
  className?: string;
}

export const ActionButton: FC<ActionButtonProps> = ({
  isLoading,
  disabled = false,
  onClick,
  children,
  style = {},
  size = 'md',
  className,
}) => {
  const buttonStyle: React.CSSProperties = {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    ...style,
  };

  return (
    <Button
      disabled={disabled || isLoading}
      onClick={onClick}
      size={size}
      style={buttonStyle}
      className={className}>
      {isLoading ? (
        <CircularProgress
          color="success"
          size={30}
          sx={{ color: colors.WHITE }}
        />
      ) : (
        children
      )}
    </Button>
  );
};
